<template>
  <div class="boxes">
    <h3><Icon type="md-bookmarks" />报警排名分析（前十）<slot name="right"></slot></h3>
    <Table :data='tableData' :columns='columns'>
      <template slot-scope="{ row }" slot="tiredAlarm">
        <span>{{ row.tiredAlarm }}次</span>
      </template>
      <template slot-scope="{ row }" slot="telAlarm">
        <span>{{ row.telAlarm }}次</span>
      </template>
      <template slot-scope="{ row }" slot="distAlarm">
        <span>{{ row.distAlarm }}次</span>
      </template>
      <template slot-scope="{ row }" slot="collideAlarm">
        <span>{{ row.collideAlarm }}次</span>
      </template>
      <template slot-scope="{ row }" slot="deviateAlarm">
        <span>{{ row.deviateAlarm }}次</span>
      </template>
      <template slot-scope="{ row }" slot="rangeAlarm">
        <span>{{ row.rangeAlarm }}次</span>
      </template>
      <template slot-scope="{ row }" slot="smokeAlarm">
        <span>{{ row.smokeAlarm }}次</span>
      </template>
      <template slot-scope="{ row }" slot="alarmTotal">
        <span>{{ row.alarmTotal }}次</span>
      </template>
    </Table>
  </div>
</template>
<script>
export default {
  data() {
    return {

      tableData: [

      ],
      columns: [
        {
          title: "排名",
          type: 'index',
          width: 100,
        },
        {
          title: "车牌号",
          key: "carNo",
        },
        {
          title: "所属单位",
          key: "groupName",
        },
        {
          title: "疲劳驾驶报警",
          key: "tiredAlarm",
          slot: 'tiredAlarm',
        },
        {
          title: "接打电话报警",
          key: "telAlarm",
          slot: 'telAlarm',
        },
        {
          title: "分神驾驶报警",
          key: "distAlarm",
          slot: 'distAlarm',
        },
        {
          title: "前向碰撞报警",
          key: "collideAlarm",
          slot: 'collideAlarm',
        },
        {
          title: "车道偏离报警",
          key: "deviateAlarm",
          slot: 'deviateAlarm',
        },
        {
          title: "车距过近报警",
          key: "rangeAlarm",
          slot: 'rangeAlarm',
        },
        {
          title: "抽烟报警",
          key: "smokeAlarm",
          slot: 'smokeAlarm',
        },
        {
          title: "报警总数",
          key: "alarmTotal",
          slot: 'alarmTotal',
        },
      ],
    };
  },
  methods: {
    getData(v) {
      v.limit = 10;
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-car-server-oam/report/countRank",
        data: v,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.tableData=res.data.data;
      });
    },
  },
  mounted() {
    
  },
};
</script>
<style>
#kdkdkdk {
  width: 100%;
  height: 400px;
}
</style>


// WEBPACK FOOTER //
// src/components/dataAnalyse/anaReports/baojingpaiming.vue